
import { API } from '../network/API';

export async function questionAssistent ({ message, url, conversationId, mode }) {
  const params = {};
  params.body = { message, url, conversationId, mode };
  return await API.post('AiAssistentAPI', '/conversation/quest', params);
}

export async function getLatestAiSession () {
  const params = {};
  return await API.get('AiAssistentAPI', '/assistant/conversation/quest/last', params);
}
